{
  "version": 1,
  "asset_id": "832f7a45-ba7f-4dad-a6c6-add6ed2f1c16",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/832f7a45-ba7f-4dad-a6c6-add6ed2f1c16/hiatal-type-2-es-v3-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/832f7a45-ba7f-4dad-a6c6-add6ed2f1c16/hiatal-type-2-es-v3-1200.jpg",
  "original_filename": "hiatal-type-2-es-v3-1200.jpg",
  "size": 277347,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T19:42:23Z"
}
